import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Utils from "../../../utility";
import { buyerService } from "../../../services/index";
import Loader from "../../../common/components/tablesLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    borderBottom: "none",
  },
  container: {
    maxHeight: 890,
  },
  Card: {
    maxHeight: 20,
  },
  Avatar: {
    maxHeight: 25,
    maxWidth: 25,
  },

  link: {
    "& > * + *": {
      marginLeft: theme.spacing(51),
    },
  },
  Table: {
    "&:nth-of-type(odd)": {
      backgroundColor: "white",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "red",
    },
  },
}));

export default function StickyHeadTable() {
  const preventDefault = (event) => event.preventDefault();
  const classes = useStyles();
  const [isLoading, setLoading] = React.useState(true);
  // const [page, setPage] = React.useState(0);
  const [buyer, setBuyer] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  useEffect(() => {
    getBuyer();
  }, []);
  const getBuyer = async () => {
    let [error, nftbuyer] = await Utils.parseResponse(buyerService.getBuyer());
    if (error || !nftbuyer) return;
    setBuyer(nftbuyer);
    setLoading(false);
  };
  return (
    <Paper elevation={0} className={classes.root}>
      <Card className={classes.Card}>
        <Typography
          className={classes.link}
          variant="h8"
          color="#001441"
        ></Typography>
      </Card>
      <TableContainer className={classes.container} id="scrollbar-8">
        <Table stickyHeader aria-label="sticky table" className={classes.Table}>
          <TableHead>
            <TableRow>
              <TableCell align="left" id="Table-cell"></TableCell>
              <TableCell align="left" id="Table-cell" className="w-24">
                Account Name
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-25 ">
                Account ID
              </TableCell>
              <TableCell align="left" id="Table-cell" className="w-26 ">
                Collected
              </TableCell>
              <TableCell align="left" id="Table-cell">
                Total Purchased Value (XDC)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody className="table-body">
            {isLoading ? (
              <TableRow>
                <TableCell style={{ border: "none" }} colspan={12}>
                  <div className="homePageLoader">
                    <Loader />
                  </div>
                </TableCell>
              </TableRow>
            ) : (
              buyer.length !== 0?
              buyer.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => {
                return (
                  <TableRow className="table-row">
                    <TableCell align="left" className="Table-cell">
                      <img
                        style={{ width: 30, height: 30, borderRadius: "15px" }}
                        src={row.photo[0] || "/defaultprofile.png"}
                      />
                    </TableCell>
                    <TableCell
                      align="left"
                      className="Table-cell"
                      style={{ width: 345 }}
                    >
                      {row.name[0]}
                    </TableCell>
                    <TableCell
                      align="left"
                      className="Table-cell"
                      style={{ width: 325 }}
                    >
                      {row.userId[0]}
                    </TableCell>
                    <TableCell
                      align="left"
                      className="Table-cell"
                      style={{ width: 405 }}
                    >
                      {row.sold}
                    </TableCell>
                    <TableCell align="left" className="Table-cell">
                      {row.totalSellValue}
                    </TableCell>
                  </TableRow>
                ); 
              }):( <TableRow>
                  <TableCell style={{ border: "none" }} colspan={12}>
                    <div className="homeSellBuyTable">
                      <center>No data found</center>
                    </div>
                  </TableCell>
                </TableRow>)
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        id="test"
        labelRowsPerPage={
          <span style={{ color: "#8d8d8d" }}>Rows Per Page</span>
        }
        rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100]}
        component="div"
        count={buyer.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </Paper>
  );
}
